import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    margin-top: 30px;
    div {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
    }
    .skill__bar {
        display: block;
        border-radius: 10px;
        height: 5px;
        background-color: #e2b66b;

        .skill__progress {
            display: block;
            border-radius: 10px;
            height: 5px;
            width: 80%;
            background-color: #f1d9ab;
        }
    }
`

interface SkillItemProps {
    rede: string[]
}

function SkillItem({rede}: SkillItemProps) {

  return (
    <Wrapper>
        <div>
            <p>{rede[0]}</p>
            <p>{rede[1]}</p>
        </div>
        <div className="skill__bar">
            <span className="skill__progress"></span>
        </div>
    </Wrapper>
  );
}

export default SkillItem;